import { render, staticRenderFns } from "./EntryDetailPanel.vue?vue&type=template&id=6c523873&scoped=true"
import script from "./EntryDetailPanel.vue?vue&type=script&lang=js"
export * from "./EntryDetailPanel.vue?vue&type=script&lang=js"
import style0 from "./EntryDetailPanel.vue?vue&type=style&index=0&id=6c523873&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c523873",
  null
  
)

export default component.exports